import {Redirect, Route, RouteComponentProps, RouteProps} from "react-router-dom";
import React from "react";
import {useSelector} from "react-redux";
import {RootState} from "../../store/store";

interface RequireUnauthenticatedRouteProps extends RouteProps {
    component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>
}

export default function RequireUnauthenticatedRoute({ component, ...args }: RequireUnauthenticatedRouteProps) {
    const authenticated = useSelector((state: RootState) => state.authentication.accessToken !== undefined)

    if (authenticated) {
        return (
            <Redirect to="/user" />
        )
    } else {
        return (
            <Route component={(component)} {...args} />
        )
    }
}